
const letterGestures = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'G-v2', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'X-v2', 'Y', 'Y-v2', 'Z'
];

const numberGestures = [
    '0', '1', '1-v2', '2', '2-v2', '3', '3-v2', '4', '4-v2', '5', '5-v2', '6', '6-v2', '7', '7-v2', '8', '8-v2', '9', '9-v2', '10',
    '11', '12', '13', '14', '15',
    '16', '16-v2', '16-v3',
    '17', '17-v2', '17-v3',
    '18', '18-v2', '18-v3',
    '19', '19-v2', '19-v3',
    '20', '21', '22', '23', '23-v2', '24', '25', '25-v2', '26', '27', '28', '29', '30', '30-v2',
    '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '40-v2',
    '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '50-v2',
    '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '60-v2',
    '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '70-v2',
    '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '80-v2',
    '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '90-v2',
    '91', '92', '93', '94', '95', '96', '97', '98', '99'
];

const unit1Gestures = [
    'hello', 'hello-v2', 'hello_or_bye_handwave', 'handwave_applause',
    'name', 'oh-i-see', 'forget', 'slow', 'again', 'remember', 'think', 'know', 'letters', 'gesture', 'attention-getting_wave', 'meaning',
    'same', 'same-v2', 'different', 'different-v2', 'what', 'who', 'where', 'male', 'male-v2', 'female', 'female-v2', 'person',
    'red', 'red-v2', 'orange', 'orange-v2', 'yellow', 'green', 'blue', 'purple', 'purple-v2', 'pink', 'pink-v2', 'white',
    'brown', 'brown-v2', 'brown-v3', 'tan', 'black', 'gray', 'colour', 'bright', 'dark', 'dark-v2', 'dark-v3',
    'rectangle-shape', 'square-shape', 'circle-shape', 'heart-shape', 'diamond-shape', 'shape', 'triangle-shape',
    'clothes', 'shirt', 'coat', 'pants', 'pants-v2', 'hat', 'hat-v2', 'glasses', 'glasses-v2', 'cap', 'toque', 'socks', 'shoes',
    'class', 'room', 'classroom', 'door', 'window', 'lights', 'book', 'table', 'chair', 'sit', 'sit-v2', 'stand',
    'open-door', 'close-door', 'open-window', 'close-window', 'on-lights', 'on-lights-v2', 'off-lights', 'off-lights-v2', 'flash-lights',
    'paper', 'crumple', 'throw', 'open-book', 'close-book', 'read', 'look-at', 'iloveyou', 'fine',
    'thanks', 'bye', 'me', 'you', 'yes', 'no', 'help', 'please', 'nice', 'meet', 'finish', 'wrong', 'wonderful', 'wonderful-v2', 'wonderful-v3', 'sign', 'feel', 'good', 'good-v2'
];

const unit2Gestures = [
    'hearing', 'hard_of_hearing', 'deafened', 'right', 'college', 'university', 'speak',
    'sign', 'sign-v2', 'sign-v3', 'sign-v4', 'on', 'out',
    'teacher', 'student', 'student-v2', 'language', 'language-v2', 'gallaudet',
    'ready', 'ready-v2', 'first', 'win', 'lose', 'tie_or_equal', 'game', 'grow-up',
    'high-school', 'presently', 'year', 'both', 'kind-of', 'easy', 'hard',
    'english', 'english-v2', 'spanish', 'french', 'french-v2', '#ASL', 'over-there', 'here', 'still',
    'most', 'some', 'a-bit', '#ALL', '#ALL-v2', 'leisure', 'activity', 'activity-v2',
    'exercise', 'exercise-v2', 'cycling', 'running', 'hiking', 'walking', 'dancing',
    'bowling', 'play', 'play-v2', 'with', 'dog', 'cooking', 'telephone', 'telephone-v2', 'chatting', 'chatting-v2', 'chatting-v3',
    'sewing', 'knitting', 'watch', '#TV', 'picture', 'picture-v2', 'take_a_picture', 'take_a_picture_of_me', 'photography',
    'art-painting', 'shopping', 'movie', 'movie-v2', 'travel', 'camping', 'fishing', 'fishing-v2',
    'write', 'draw', 'jot-down', 'computer', 'computer-v2', 'computer-v3', 'laptop', 'tablet', 'typing', 'sleep',
    'time', 'look-at-watch', 'music', 'listen', 'coffee', 'drink',
    'soda-pop', 'candy', 'apple', 'tie-string', 'attentive', 'not',
    'inattentive', 'detest', 'like', 'prefer', 'tea', 'water',
    'milk', 'juice', 'hot', 'chocolate', '#OK', 'tired',
    'sick', 'plus', 'minus', 'how-many', 'have', 'favorite', 'kiss-fist', 'see',
    'eat', 'food', 'how', 'how-v2', 'how-v3', 'learn', 'teach', 'deaf', 'deaf-v2', 'profoundly_deaf'
];

const unit3Gestures = [
    'live', 'near', 'near-v2', 'north', 'east', 'west', 'south', 'south-v2',
    'Vancouver', 'Burnaby', 'Coquitlam', 'Richmond', 'Surrey', '#SURREY', 'Victoria',
    'island', 'city', 'city-v2', 'space', 'area', 'place', 'mountain', 'mountain-v2', '#PARK', 'park', '#MALL',
    'street', 'river', 'river-v2', 'lake', 'house', '#APT', '#CONDO', 'dorm',
    'huge-cha', 'medium-mmm', 'small-ooo', 'new', 'old', 'which', 'washroom', 'front', 'big',
    'library', 'bookstore', 'store', 'cafeteria', 'machine', '#ATM', '#LAB', '#LOBBY',
    'enter', 'to-exit', 'on-right-side', 'on-left-side', 'go-left', 'go-right',
    'hall', 'stairs-up', 'stairs-down', 'elevator', 'elevator-v2',
    'alone', 'roommate', 'boyfriend', 'girlfriend', 'sweetheart', 'family',
    'husband', 'wife', 'son', 'son-v2', 'daughter', 'daughter-v2', 'children', 'people', 'people-v2', 'pets',
    'cat', 'cat-v2', 'bird', 'fish', 'fish-v2', 'turtle', 'rat', 'rabbit', 'animal',
    'none', 'none-v2', 'put', 'put-v2', 'floor', 'shelves', 'garbage', 'garbage-v2', 'box', 'box-v2', 'cup', 'cup-v2', 'backpack', 'backpack-v2',
    'need', 'money', 'money-v2', 'practice', 'buy', 'put-up-with',
    'car', 'car-v2', 'motorcycle', '#BUS', 'bus-v2', 'train', 'skytrain', 'subway', 'subway-v2', 'ride-in', 'ride-in-v2', 'get-in-car', 'get-out-car',
    'go-someplace', 'go-someplace-v2', 'come-here', 'come-here-v2', 'home', 'home-v2', 'work', 'work-v2',
    'always', 'never', 'sometimes', 'half-hour',
    'hide', 'hide-v2', 'search', 'find', 'summon', 'bring', 'feel-down',
    'there-to-there_right-to-left', 'there-to-there_left-to-right'
];

const unit4Gestures = ['marry', 'want', 'want-v2', 'boy', 'girl', 'look-like', 'look-like-v2', 'oldest', 'only child', 'month', 'altogether', 'my', 'your',
    'he_she_they_right-side', 'he_she_they_left-side', 'his_her_their_right-side', 'his_her_their_left-side', 
    'wow', 'wow-v2', 'fall-in-love', '#DATE', 'date_exclusively', 'propose_suggest_offer', 'wedding', 'fiance_or_fiancee', 
    'conceive', 'pregnant', 'born', 'born-v2', 'baby', 'twins', 'twins-v2', 'twins-v3',
    'father', 'father-v2', 'mother', 'mother-v2',
    'grandpa', 'grandpa-v2', 'grandma', 'grandma-v2', 'grandson', 'granddaughter', 'grandchildren', 
    'aunt', 'uncle', 'niece', 'niece-v2', 'nephew', 'nephew-v2', 'cousin-male', 'cousin-male-v2', 'cousin-female', 'cousin-female-v2', 'cousins-non-specific', 
    'in-law', 'key', 'for', 'what-for', 'pretty_or_beautiful', 'good_looking', 'cute', 'young', 'face_or_looks', 'stay-same', 'future', 
    'dont-want', 'maybe', 'true', 'none', 'last', 'two-of-you', 'two-of-us', 'close-bond', 'interesting', 'interesting-v2', 'age', 'dead', 'gone', 
    'half', 'half-v2', 'step', 'step-v2', '#STEP', 'partner', 'partner-v2', 'gay', 'lesbian', 'straight', 'bi', 'trans', 'queer', 
    'adopt', 'adopt-v2', 'take_care_of', 'quarrel', 'get-along', 'not_get-along', 'fade-away', 'part aways', 'separate', 'divorce', 'divorce-v2', 'divorce-v3', 
    'birthday', 'birthday-v2', 'celebrate_or_anniversary', 'reunion', 'gather', 'christmas', 'christmas-v2', 'hannukah', 'thanksgiving', 'thanksgiving-v2', 
    'holiday', 'holiday-v2', 'vacation', 'vacation-v2', 'graduation', '#JAY', '#JANE', '#JEFF', '#JEN', '#JILL', '#JIM', '#JOY', '#JOE', '#JURY', '#JUDY'
];

const unit5Gestures = ['please', 'when', 'do_or_did', 'do_or_did-v2', 'past', 'sunday', 'sunday-v2', 
    'monday', 'tuesday', 'wednesday', 'thursday', 'thursday-v2', 'thursday-v3', 'friday', 'saturday', 'saturday-v2', 'stay-1h', 'clean', 'cooking-v2', 
    'go_someplace-v2', 'leave_for', 'study', 'study-v2', 'practice', 'soccer', 'meeting', 'see', 'doctor', 'doctor-v2', 'take-out-of', 
    'friend', 'shopping', 'school', 'gym', 'gym-v2', 'church', 'hospital', '#BANK', 'resturant', 
    'show_me-to-you', 'show_you-to-me', 'show_right-to-left', 'show_left-to-right', 'give_me-to-you', 'give_you-to-me', 
    'give_right-to left', 'give_left-to-right', 'ask_me-to-you', 'ask_you-to-me', 'ask_right-to-left', 'ask_left-to-right', 
    'tell_me-to-you', 'tell_you-to-me', 'tell_right-to-left', 'tell_left-to-right', 'take_me-from-you', 'take_you-from-me', 
    'take_right-to-left', 'take_left-to-right', 'throw_me-to-you ', 'throw_you-to-me', 'throw_right-to-left', 'throw_left-to-right', 
    'throw_me-to-you-v2', 'throw_you-to-me-v2', 'throw_right-to-left-v2', 'throw_left-to-right-v2', 
    'newspaper', 'shelves-v2', 'wipe-down', 'vacuum', 'sweep', 'sweep-v2', 'take_care', 'dishes', 'wash', 'wash-v2', 
    'laundry', 'out', 'outside', 'outside-v2', 'inside', 'empty_the_pail', 'feed', 'feed-v2', '#BILLS', 'pay-singular', 'pay-plural',
    'plants', 'plants-v2', 'pour', 'pour-v2', 'fold', 'put_away', '#FIX', 'fix', 'fix-v2', 'inspect_or_research', 'task_or_chore', 'dont_mind', 
    'not yet', 'drop off', 'haircut', 'haircut-v2', 'medicine', 'pick_up', 'pick_up-v2', 'borrow', 'rent-monthly', 
    'dry', 'wet', 'teeth', 'dentist', 'dentist-v2', 'dentist-v3', 'gas', 'full', 'fill_up_or_maximum', 'garage', '#OIL', 'change', 'change-v2', 'change-v3', 
    '#VET', 'shots-medicine', 'shots-medicine-v2', 'volunteer', 'help-v2', 'pack', 'move', 'move_away', '#PO', '#DRUG', '#ZOO', 
    'have_to', 'refuse', 'sympathy-for-you', 'everyday', 'week', 'last_week', 'last_week-v2', 'next_week', 'next_week-v2', 'weekend', 'weekend-v2', 'weekend-v3',
    'morning', 'noon', 'afternoon', 'evening', 'all_day', 'all_night', 'all_day_and_night', 
    'two-of-us', 'two-of-you', 'two-of-them', 'three-of-us', 'three-of-you', 'three-of-them', 
    'four-of-us', 'four-of-you', 'four-of-them', 'five-of-us', 'five-of-you', 'five-of-them', 'all-of-us', 'all-of-you', 'all-of-them',
     'skiing', 'swimming', 'sightseeing', 'host', 'party', 'party-v2', 'party-v3', 'visit', 'visit-v2', 'blizzards', '#POOL', 'basketball', 
     'beach', 'beach-v2', '#BEACH', 'museum', 'bar', '#CLUB', 'amusement_park', 'fun', '#FUN', 'since', 'same-old', 'join-me', 'sorry', 'cant',
    'night', 'tomorrow', 'yesterday', 'yesterday-v2', 'and', 'excited', 'now', 'before'
];

const unit6Gestures = ['tree', 'hungry', 'thirsty', 'sandwich', 'sandwich-v2', 'thumbs_up', 'two_thumbs_up', 
    'gum', 'yell_or_call_out', 'stuck', 'look-at-me', 'laurent_clerc', 'united_states_of_america', '#USA', 'boat', 'arrive', 'heard', 
    'establish', 'sometime_in_the_past', 'a_long_time_ago', 'next', 'cry', 'cry-v2', 'whats_the_matter', 'laugh', 'laugh-v2', 'laugh-v3', 
    'mirror', 'broken', 'realize', 'understand', 'jump', 'jump_off', 'fly', 'kitchen', 'egg', 'eggs', 'cookies', 'delicious', 'wait', 'wait-v2', 
    'smell', 'accidentally', 'instantly', 'pain', 'bring away', 'mad', 'angry', 'early', 'early-v2', 'early-v3', 'early-v4', 'late', '#HAHA', 
    'sometime_later', 'thought_of_something', 'bed', 'bed-v2', 'bath', 'say', 'ghost', 'ghost-v2', 'friendly', 'mean', 'mess', 'cool', 
    'then', 'than', 'later', 'later-v2',
    'hilarious', 'technology', 'use', 'finally', 'communicate', 'this', 'this-v2', 'impossible', 'possible'
];

const numberingSystemGestures = [
    '1-minute', '1-minute-v2', '2-minute', '2-minute-v2', '3-minute', '3-minute-v2', '4-minute', '4-minute-v2', '5-minute', '5-minute-v2',
    '6-minute', '6-minute-v2', '7-minute', '7-minute-v2', '8-minute', '8-minute-v2', '9-minute', '9-minute-v2',
    '1-hour', '1-hour-v2', '2-hours', '2-hours-v2', '3-hours', '3-hours-v2', '4-hours', '4-hours-v2', '5-hours', '5-hours-v2',
    '6-hours', '6-hours-v2', '7-hours', '7-hours-v2', '8-hours', '8-hours-v2', '9-hours', '9-hours-v2',
    'once', 'twice', 'thrice', 
    'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 
    'first_of_two', 'second_of_two', 'first_of_three', 'second_of_three', 'third_of_three', 'first_of_four', 'second_of_four', 'third_of_four', 'fourth_of_four', 
    'first_of_five', 'second_of_five', 'third_of_five', 'fourth_of_five', 'fifth_of_five', 
    '1-years-old', '2-years-old', '3-years-old', '4-years-old', '5-years-old', '6-years-old', '7-years-old', '8-years-old', '9-years-old', '10-years-old', 
    '11-years-old', '12-years-old', '13-years-old', '14-years-old', '15-years-old', '16-years-old', '17-years-old', '18-years-old', '19-years-old', '20-years-old', 
    '21-years-old', '22-years-old', '23-years-old', '24-years-old', '25-years-old', '26-years-old', '27-years-old', '28-years-old', '29-years-old', '30-years-old', 
    '2-months', '3-months', '4-months', '5-months', '6-months', '7-months', '8-months', '9-months'
];

// const extraGestures = [
//     '#AI', '#DO', 'interpreting', 'in', 'real-time', 'will', '#BE', 'connection', 'human', 'should', 'because', '#OF',
//     'cost', 'available', 'we', 'can', 'make', 'access', 'afford', 'anytime', 'anywhere', 'any', 'is_are_real', 'include', '#OR', 'idle'
// ];

// Special cases for gesture display names
const specialDisplayNames = {
    'there-to-there_right-to-left': 'there-to-there (right to left)',
    'there-to-there_left-to-right': 'there-to-there (left to right)',
    'is_are_real': 'is/are/real',
    'he_she_they_right-side': 'he/she/they (person on right side)',
    'he_she_they_left-side': 'he/she/they (person on left side)',
    'his_her_their_right-side': 'his/her/their (person on right side)',
    'his_her_their_left-side': 'his/her/their (person on left side)',
    'what-for': 'what for?',
    'propose_suggest_offer': 'propose/suggest/offer',
    'fiance_or_fiancee': 'fiancé/fiancée',
    'dont_want': 'don\'t want',
    'stay-1h': 'stay (1h)',
    'pay-singular': 'pay (singular)',
    'pay-plural': 'pay (plural)',
    'dont_mind': 'don\'t mind',
    'rent-monthly': 'rent (monthly)',
    'shots-medicine': 'shots (medicine)',
    'shots-medicine-v2': 'shots (medicine) [v2]',
    '#PO': '#PO (Post Office)',
    'cant': 'can\'t',
    'whats_the_matter': 'what\'s the matter'
};

// Helper function to format gesture names for display in the UI
export const formatGestureForDisplay = (gesture) => {
    // Check for special cases first
    if (specialDisplayNames[gesture]) {
        return specialDisplayNames[gesture];
    }

    let formatted = gesture;

    // Replace "_or_" with "/"
    formatted = formatted.replace(/_or_/g, '/');

    // Replace remaining underscores with spaces
    formatted = formatted.replace(/_/g, ' ');

    // Handle version suffix pattern (e.g., "-v2", "-v3")
    if (/-v\d+$/.test(formatted)) {
        const [prefix, version] = formatted.split('-v');
        return `${prefix} [v${version}]`;
    }

    return formatted;
};

export const categories = [
    { id: 'letters', label: 'Letters', gestures: letterGestures },
    { id: 'numbers', label: 'Numbers', gestures: numberGestures },
    { id: 'unit1', label: 'Unit 1', gestures: unit1Gestures },
    { id: 'unit2', label: 'Unit 2', gestures: unit2Gestures },
    { id: 'unit3', label: 'Unit 3', gestures: unit3Gestures },
    { id: 'unit4', label: 'Unit 4', gestures: unit4Gestures },
    { id: 'unit5', label: 'Unit 5', gestures: unit5Gestures },
    { id: 'unit6', label: 'Unit 6', gestures: unit6Gestures },
    { id: 'numberingSystems', label: 'Numbering Systems', gestures: numberingSystemGestures },
    // { id: 'extra', label: 'Extra', gestures: extraGestures }
];

export const allGestures = [
    ...letterGestures,
    ...numberGestures,
    ...unit1Gestures,
    ...unit2Gestures,
    ...unit3Gestures,
    ...unit4Gestures,
    ...unit5Gestures,
    ...numberingSystemGestures,
    // ...extraGestures
];

// Helper function to find which category a gesture belongs to
export const findGestureCategory = (gesture) => {
    return categories.find(category => category.gestures.includes(gesture));
};